import { t } from "i18next";
import React, { lazy } from "react";
import { useLanguage } from "../../context/LanguageContext";
const LazyHero = lazy(() => import("../../components/Hero"));

const Impact = () => {
  const { currentLanguageCode } = useLanguage();
console.log(currentLanguageCode);

  const breadcrumb = [
    { label: t("home.home"), href: "/" },
    { label: "Impact", href: "#" },
  ];
  return (
    <>
      <section className="pb-5">
        <div className="container">
          <LazyHero breadcrumb={breadcrumb} />

          <div className="row justify-content-center">
            <div className="col-md-10">
              {currentLanguageCode == "en" ? (
                <img src="/assets/images/impact/infograph-english.jpeg" alt="" className="w-100"/>
              ) : currentLanguageCode == "de" ? (
                <img src="/assets/images/impact/infograph-german.jpeg" alt="" className="w-100"/>
              ) : (
                <img src="/assets/images/impact/infograph-indoneisan.jpeg" alt="" className="w-100" />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Impact;
